var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MyADGMeetings.jinja');
require('./MyADGMeetings.less');

var MyADGMeetingsInner = require('front/components/MyADGMeetings/MyADGMeetingsInner');

var MyADGMeetingsTemplate = require('front/components/MyADGMeetings/MyADGMeetingsInnerRuntime.jinja');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MyADGMeetings-showMoreButton': 'onClickMoreButton',

        'click .MyADGMeetings-meetingMinutesButton': 'onClickMeetingMinutesButton',

        'click .MyADGMeetings-meetingMinutesCategories-close': 'onClickMeetingMinutesCategoriesClose',
        'click .MyADGMeetings-meetingMinutesCategories': 'onClickMeetingMinutesCategories',
        'click .MyADGMeetings-meetingMinutesCategories-listItem': 'onClickMeetingMinutesCategoriesListItem',

        'click .MyADGMeetings-meetingMinutes-close': 'onClickMeetingMinutesClose',
        'click .MyADGMeetings-meetingMinutes': 'onClickMeetingMinutes',

        'touchstart .MyADGMeetings-meetingMinutes': 'onTouchStart',
        'touchmove .MyADGMeetings-meetingMinutes': 'onTouchMove'
    },

    moreApi: function () {
        return this.state.next;
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'MyADGMeetingsInner': {selector: '.MyADGMeetingsInner', viewConstructor: MyADGMeetingsInner}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'moreApi', 'onResize');

        var limit = 5;

        this.state = {
            next: Urls['front:api:my_adg_meetings']() + '?offset=' + this.$('.MyADGMeetingsInner-item').size(),
            hasMore: false
        };

        if (!app.settings.isPhone) {
            this.popupJsp = $('.MyADGMeetings-meetingMinutes-scrollBlock')
                .jScrollPane({verticalGutter: 0, contentWidth: '0px'})
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');
        }

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        $(window).on('resize', this.onResize);

        this.onResize();
    },


    destroy: function () {
        $(window).off('resize', this.onResize);

        return Base.prototype.destroy.call(this);
    },


    onResize: function () {
        this.popupJsp && this.popupJsp.reinitialise();
    },


    onTouchStart: function (e) {
        this.meetingsScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onTouchMove: function (e) {
        if (!app.settings.isPhone) return;


        var $scrollbox = this.$('.MyADGMeetings-meetingMinutes-mobileScrollBox');
        var $target = $(e.target);
        var delta = this.meetingsScrollY - e.originalEvent.touches.item(0).clientY;

        if (!$target.closest($scrollbox).length) {
            e.preventDefault();
        }

        if ((delta < 0 && $scrollbox.scrollTop() <= 0) ||
            (delta > 0 && $scrollbox.scrollTop() + $scrollbox.height() >= $scrollbox[0].scrollHeight)) {
            e.preventDefault();
        }

        this.meetingsScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onClickMoreButton: function (e) {
        var self = this;
        this.$('.MyADGMeetings-showMoreButton').addClass('Button--loading');

        this.forceLoadData(this.moreApi)
            .then(function () {
                self.state.next = self.data.next;
                var $meetings = $(MyADGMeetingsTemplate.render({data: self.data.results}));
                self.state.hasMore = !!self.state.next;

                self.$('.MyADGMeetings-listWrapper').append($meetings);

                app.animateShowMoreSlideDown({$items: $meetings, hasWrapper: true});

                self.$('.MyADGMeetings-showMoreButton')
                    .toggle(!!self.state.hasMore)
                    .removeClass('Button--loading');

                new MyADGMeetingsInner({
                    el: $meetings[0]
                });
            });
    },


    onClickMeetingMinutesButton: function () {
        this.$('.MyADGMeetings-meetingMinutesCategories').addClass('MyADGMeetings-meetingMinutesCategories--opened');
    },



    onClickMeetingMinutesCategoriesClose: function () {
        this.$('.MyADGMeetings-meetingMinutesCategories').removeClass('MyADGMeetings-meetingMinutesCategories--opened');
    },


    onClickMeetingMinutesCategories: function (e) {
        if ($(e.target).closest('.MyADGMeetings-meetingMinutesCategories-content').length) return;

        this.onClickMeetingMinutesCategoriesClose();
    },


    onClickMeetingMinutesCategoriesListItem: function (e) {
        var $item = $(e.currentTarget);
        var id = $item.attr('data-id');
        var title = $item.attr('data-title');

        this.$('.MyADGMeetings-meetingMinutes h3').text(title + ' meeting minutes');

        this.$('.MyADGMeetings-meetingMinutes li').hide();
        this.$('.MyADGMeetings-meetingMinutes li[data-category-id="' + id + '"]').show();
        this.popupJsp && this.popupJsp.reinitialise();

        this.$('.MyADGMeetings-meetingMinutes').addClass('MyADGMeetings-meetingMinutes--opened');
    },


    onClickMeetingMinutesClose: function () {
        this.$('.MyADGMeetings-meetingMinutes').removeClass('MyADGMeetings-meetingMinutes--opened');
    },


    onClickMeetingMinutes: function (e) {
        if ($(e.target).closest('.MyADGMeetings-meetingMinutes-content').length) return;

        this.onClickMeetingMinutesClose();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGMeetings/MyADGMeetings.js
// module id = 221
// module chunks = 0